import { render, staticRenderFns } from "./AdvertisingPage.vue?vue&type=template&id=1c1a85bc&scoped=true&"
import script from "./AdvertisingPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisingPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingPage.vue?vue&type=style&index=0&id=1c1a85bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a85bc",
  null
  
)

export default component.exports